module.exports = __webpack_public_path__ + "img/Arrow_Back.b1747afd.svg";